import { ReactNode } from "react";

interface ChartWrapperProps {
  children: ReactNode;
  title: string;
}

export default function ChartWrapper({ children, title }: ChartWrapperProps) {
  return (
    <div className="bg-white border-r border-b border-gray-200 h-full flex flex-col">
      <div className="px-3 py-2 border-b border-gray-100 flex-shrink-0">
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      </div>
      <div className="flex-1 min-h-0">{children}</div>
    </div>
  );
}
